import { render, staticRenderFns } from "./wxBindChange.vue?vue&type=template&id=2f2e14b9"
import script from "./wxBindChange.vue?vue&type=script&lang=js"
export * from "./wxBindChange.vue?vue&type=script&lang=js"
import style0 from "./wxBindChange.vue?vue&type=style&index=0&id=2f2e14b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports